import script from "./CommentInputModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentInputModal.vue?vue&type=script&setup=true&lang=js"

import "./CommentInputModal.vue?vue&type=style&index=0&id=297391b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-297391b2"]])

export default __exports__